import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';
import { InputWrapper } from '../css';
import { Box, Text } from '../../design/css';

const TypeAhead = ({
  options,
  onChange,
  selected = [],
  label,
  placeholder,
  disabled = false
}) => {
  const ref = useRef();

  useEffect(() => {
    if (!selected.length) {
      ref.current.clear();
    }
  }, [selected]);

  return (
    <InputWrapper>
      <Box>
        <Text bold>{label}</Text>
        <Typeahead
          id="basic-typeahead"
          labelKey="label"
          disabled={disabled}
          options={options}
          onChange={onChange}
          placeholder={placeholder}
          selected={selected}
          ref={ref}
          clearButton
        />
      </Box>
    </InputWrapper>
  );
};

TypeAhead.propTypes = {
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.any),
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default TypeAhead;
